module.exports = __webpack_public_path__ + "Flag-76.e236c1385687d5d12f21fa8cc1dbf65b.svg";